'use client';

import type { ReactNode } from 'react';
import clsx from 'clsx';

type DialogActionGridProps = {
    templatesAction: ReactNode;
    autoRepliesAction: ReactNode;
    aiAction: ReactNode;
    editAction?: ReactNode;
    primaryAction: ReactNode;
    className?: string;
};

const actionSlotClassName = 'min-w-0 h-full [&>*]:h-full [&>*]:w-full';

export const DialogActionGrid = ({
    templatesAction,
    autoRepliesAction,
    aiAction,
    editAction,
    primaryAction,
    className,
}: DialogActionGridProps) => (
    <div
        data-testid="dialog-action-grid"
        className={clsx('grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(108px,1fr)] grid-rows-2 gap-2', className)}
    >
        <div className={actionSlotClassName}>{templatesAction}</div>
        <div className={actionSlotClassName}>{aiAction}</div>
        <div data-testid="dialog-action-grid-primary" className="row-span-2 min-w-0 h-full [&>*]:h-full [&>*]:w-full">
            {primaryAction}
        </div>
        <div className={actionSlotClassName}>{autoRepliesAction}</div>
        <div className={actionSlotClassName}>{editAction ?? null}</div>
    </div>
);
